const data = [
    {
        question: "Who operates Prime Asset Flow?",
        answer: "Prime Asset Flow is an online investment platform. For details about the company behind the platform, please contact our support team at support@primeassetflow.com."
    },
    {
        question: "What do I need to do to start investing with Prime Asset Flow?",
        answer: "If you are reading this text you already have the required minimum, which is the Internet connection and the computing device. To create investment deposit you will also need to have funds in one of available online Bitcoin Wallets such as Blockchain.info, Binance, Cex, Metamask, Paypal, Paxful, Localbitcoins, Xapo or Coinbase wallet, etc. We work with all Bitcoin wallets. Making deposit is as easy as clicking the corresponding button within your personal Prime Asset Flow account and following the instructions provided along the way."
    },
    {
        question: "When the market isn't favorable, will I lose my capital or profit earned?",
        answer: "All trading carries risk, and losses are possible in any market. At Prime Asset Flow, our team uses automated tools and strategy to manage risk in both bearish and bullish markets."
    },
    {
        question: "How does it work?",
        answer: "A client chooses a plan and invests then the investment capital is used for trade. With trading bots and our master class strategy we make profitable entries with minimal loss from the crypto market."
    },
    {
        question: "How can I participate in the Affiliate Program?",
        answer: "Every customer is free to join our affiliate program without any additional effort. Simply create an account and sign in. Download a wallet that's availiable in your country, fund your wallet by purchasing your desired coin you want to invest in e.g Bitcoin, Ethereum, Tether, Shiba, Tron, Doge and Binance coin e.t.c."
    },
    {
        question: "What payment nethods are supported?",
        answer: "We currently accept payments through Bitcoin, Etheruem, Binance coin, Tronlink (TRC20), Tether (USDT), Shiba Inu."
    },
    {
        question: "How can I withdraw my profit?",
        answer: "On your profile menu, click on the withdrawal tab and complete the withdrawal process. Kindly hold while your profits withdrawal is processed."
    },
    {
        question: "Is there a charge for creating an account?",
        answer: "There is absolutely no charge for creating an account i.e creating an account does not require any additional costs or fees. Just click on the sign up page and input your details then complete your registration."
    },
    {
        question: "Will I still do any other thing once I invest to keep earning?",
        answer: "No. Once you invest with Prime Asset Flow your job is to monitor your dashboard for your daily income. Contact our support team if your daily profits didn't reflect on your dashboard."
    },
    {
        question: "How can I invest?",
        answer: "Contact our 24/7 support service from our website or telegram channel to send you the Company's Wallet ID for your desired coin you want to invest in, then send the coin that worth the amount you want to invest in. Afterwards, send a screenshoot of payment as a proof for confirmation to the admin."
    },
    {
        question: "What do I need to consider when making transactions?",
        answer: "As already mentioned, we do not charge any fees. However, this does not apply to the coin network. Every transaction requires fees which are sent to the coin network. The major factor to consider is that these transactions normally takes about five(5) to fifty(50) minuites for confirmations depending on the amount of the indicated fees. Kindly hold while your transactions are been confirmed."
    },
    {
        question: "What is the minimum amount to be deposited?",
        answer: "The minimum amount is $100 and the maximum is unlimited."
    },
    {
        question: "Can I make additional investments at any time?",
        answer: "Yes, there is no limitation. You can make as many deposit as you want."
    },
    {
        question: "Is my return of investment guaranteed?",
        answer: "No investment return can be guaranteed, and the value of your investment may go down as well as up. We use encrypted, trusted protection for your account and work hard to deliver the best possible results for our investors."
    },
    {
        question: "Is it availiable in my country?",
        answer: "Yes. Any individual from any country may open an account with us and we are happy to accept investors from any place in the world. Tell the admin the country you're chatting from to be assisted with the recommended bitcoin wallet."
    },
    {
        question: "What broker does Prime Asset Flow use?",
        answer: "We trade with MetaTrader4 & MetaTrader5 with IQ Options for binary."
    },
    {
        question: "Where is Prime Asset Flow located?",
        answer: "Prime Asset Flow operates online and serves investors worldwide. Contact our support team at support@primeassetflow.com for more information."
    },
    {
        question: "How long has Prime Asset Flow been operating?",
        answer: "For information about our company history, please contact our support team at support@primeassetflow.com."
    },
    {
        question: "What do I do if I have questions and problems?",
        answer: "Contact our 24/7 hours support team from our website or our telegram channel."
    },
    {
        question: "What is the main idea behind the establishment of Prime Asset Flow?",
        answer: "Our goal is to provide to our customers a user-friendly investment platform. This is why we have extensive infrastructure. Any of our clients can start with a simple click as soon as they are ready without any knowledge required."
    },
    {
        question: "You seem to provide a quite lucrative interest rate for a limited period of time. Where are the funds coming from?",
        answer: "Prime Asset Flow has a team of experienced traders and financial analysts whose experience and strategies drive our trading results. Returns are not guaranteed."
    },
    {
        question: "What makes Prime Asset Flow different?",
        answer: "We take a modern approach to invest. We measure ourselves not only by what we do but by how we do it. Every action and decision is based on building trust and seeing things from the view of our investors. At Prime Asset Flow, we believe in putting investors first. We champion investors and those who serve them because we believe everyone should have the opportunity to achieve great financial outcomes."
    }
]

export default data